<template>
  <div class="custPopUpMain">
    <TabView class="custTabView" :tabs="tabsItems" :activeTab="activeTab" @tabChanged="tabChanged"/>

    <Loader :isVisible="loadShow" :loadingText="loadText" />
  </div>
</template>

<script>
  /* eslint-disable */
  import Menu from '@/components/Menus.vue';
  import Tabulator from '@/components/Tabulator.vue';
  import EntryPopup from '@/components/EntryPopup.vue';
  import TabView from '@/components/TabView.vue';
  import Input from '@/components/Input.vue';
  import InputQuery from '@/components/InputQuery.vue';
  import DateTime from '@/components/DateTimePicker.vue';
  import Dropdown from '@/components/Dropdown.vue';
  import Loader from '@/components/Loader.vue';
  
  export default {
    name: 'customer',
    components: {
      Menu, Tabulator, EntryPopup, Input, InputQuery, DateTime, Dropdown, TabView, Loader
    },
    data() {
      return {
        //-------- Main Data
        
        //-------- Tabs Data
        activeTab: 0,
        tabsItems: [
          { title: 'General', component: 'CustomerGeneralV2', data: this.data, enabled: true },
          { title: 'Contact', component: 'ContactDetails', data: this.data, enabled: true },
          { title: 'Billing', component: 'CustomerBillingV2', data: this.data, enabled: true },
          { title: 'Credit Management', component: 'CustomerCreditV2', data: this.data, enabled: true },
          { title: 'Sales & Service Team', component: 'CustomerSalesServiceV2', data: this.data, enabled: true },
          { title: 'Attachments', component: 'Attachments', data: this.data, enabled: true },
          { title: 'GST ', component: 'GSTDetails', data: this.data, enabled: true },
        ],

      }
    },
    props: {
      //-------- Main Props
      data: { type: Object, default: function () { return {} } },
      viewMode: { type: Boolean, default: false },
    },
    mounted() {
      this.$bus.$on('tabChanged', this.tabChanged);
    },
    methods: {
      custBtnClick: async function(btn) {
        switch(btn) {
          case 'test':
            break;
        }
      },
      tabChanged: async function(tab) {
        this.activeTab = tab;
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
    },
  };
</script>

<style scoped>

  .custPopUpMain {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

</style>
